var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_234_13856",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_234_13856)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.20002 2.3999C6.53729 2.3999 6.00002 2.93716 6.00002 3.5999V4.7999H4.80002C3.47454 4.7999 2.40002 5.87442 2.40002 7.1999V19.1999C2.40002 20.5254 3.47454 21.5999 4.80002 21.5999H19.2C20.5255 21.5999 21.6 20.5254 21.6 19.1999V7.1999C21.6 5.87442 20.5255 4.7999 19.2 4.7999H18V3.5999C18 2.93716 17.4628 2.3999 16.8 2.3999C16.1373 2.3999 15.6 2.93716 15.6 3.5999V4.7999H8.40002V3.5999C8.40002 2.93716 7.86276 2.3999 7.20002 2.3999ZM7.20002 8.3999C6.53729 8.3999 6.00002 8.93717 6.00002 9.5999C6.00002 10.2626 6.53729 10.7999 7.20002 10.7999H16.8C17.4628 10.7999 18 10.2626 18 9.5999C18 8.93717 17.4628 8.3999 16.8 8.3999H7.20002Z",
    fill: "#FFB829"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/media/icon_calendar.5a91001efdf1d69ca732b107ce45ccb3.svg";
export { ForwardRef as ReactComponent };